<template>
  <!--  企业库-->
  <div>
    <el-dialog
      :fullscreen="true"
      :show-close="false"
      :visible.sync="dialogFormVisible"
    >
      <div
        @click="handleCancle"
        class="flex justify-between align-center"
        style=""
      >
        <div class="cursor" style="font-size: 22px">
          {{ title }}
        </div>
        <i class="el-icon-close" style="font-size: 30px"></i>
      </div>

      <div class="tips_box" ref="tips_box">
        <div><img src="@/assets/tips_icon.png" alt="" /> 操作提示</div>
        <div>· 该页面可选择所有项目的对应报价。</div>
        <div>· 检测项目支持一键全选。</div>
        <!-- 右上角隐藏 -->
        <div @click="$tools.hideTags($refs.tips_box)" class="triangle"></div>
        <div class="white_line"></div>
      </div>

      <el-row>
        <el-col :span="4"
          ><div class="grid-content bg-purple">产品分类</div></el-col
        >
        <el-col :span="4"
          ><div class="grid-content bg-purple">检测分类</div></el-col
        >
        <el-col :span="4"
          ><div class="grid-content bg-purple">检测标准</div></el-col
        >
        <el-col :span="4"
          ><div class="grid-content bg-purple">检测项目</div></el-col
        >
        <el-col :span="4"
          ><div class="grid-content bg-purple">单价</div></el-col
        >
        <el-col :span="4"
          ><div class="grid-content bg-purple">已选择检测项目</div></el-col
        >
      </el-row>

      <!-- 1105 新-->
      <el-row class="row-bg">
        <div
          v-for="(item, idx) in check_id"
          :key="idx"
          style="width: 100%; min-height: 300px"
        >
          <el-col :span="4">
              <el-select
                filterable
                class="myinput"
                v-model="item.productClass"
                placeholder="请选择检测产品"
                @change="getProductSelect(item.productClass)"
              >
                <el-option
                  v-for="(item, index) in testing_product_classify"
                  :key="index + 222"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
          </el-col>

          <el-col :span="4" class="">
              <el-checkbox-group
                v-model="item.detectionClassArr"
                class="checkbox_group overflow_scroll_box border_x padding_10"
                style=""
                @change="getStandardSelect(item.detectionClassArr)"
              >
                <el-checkbox
                  v-for="item in detectionClassList"
                  :key="item.key"
                  :label="item.key"
                  :value="item.key"
                  >{{ item.value }}</el-checkbox
                >
              </el-checkbox-group>
          </el-col>

          <el-col :span="4" class="padding_10">
              <el-checkbox-group
                v-model="item.check_idArr"
                class="checkbox_group overflow_scroll_box padding_10"
                @change="getTestproject(item.check_idArr)"
              >
                <el-checkbox
                  v-for="item in standartList"
                  :key="item.key"
                  :label="item.key"
                  :value="item.key"
                  >{{ item.value }}</el-checkbox
                >
              </el-checkbox-group>
          </el-col>

          <el-col :span="4" class="padding_10 check_all_box">
              <div
                class="padding_10 check_all"
                style="display: flex; justify-content: space-between"
              >
                <div
                  v-if="standartList.length > 0 && testProjectList.length > 0"
                >
                  <el-checkbox @change="handleAll" v-model="allChecked"
                    >全选</el-checkbox
                  >
                </div>
              </div>
              <el-checkbox-group
                v-model="item.entrustment_Inspection_list"
                class="checkbox_group overflow_scroll_box border_x padding_10"
              >
                <el-checkbox
                  v-for="item in testProjectList"
                  :key="item.key"
                  :label="item.key"
                  :value="item.key"
                  @change="entrustment_Inspection_AloneChange(item)"
                  >{{ item.value }}</el-checkbox
                >
              </el-checkbox-group>
          </el-col>

          <el-col :span="4" class="padding_10">
              <div class="overflow_scroll_box">
                <div
                  v-for="(item, index) in hasdetectionClassLists"
                  :key="index"
                  style="padding:10px 0;"
                >
                  <span class="text-price"
                    >{{ item.price?item.price:'-' }}</span
                  >
                </div>
              </div>
          </el-col>

          <el-col :span="4" class="padding_10">
              <div class="overflow_scroll_box">
                <div
                  v-for="(item, index) in hasdetectionClassLists"
                  :key="index"
                >
                  <span
                    >{{ item.product_title }}-{{ item.category_title }}-{{
                      item.standard_title
                    }}-</span
                  >
                  <span style="font-weight: 800; font-size: 15px">
                    {{ item.value }}</span
                  >
                </div>
              </div>
          </el-col>
        </div>
      </el-row>

      <div class="sure_btn">
         <el-button type="primary" @click="handleSure">确认添加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: "添加",
    },
    type: {
      type: String,
      default: "add",
    },
    id: {
      type: String,
      default: "",
    },
    check_id:{
      type: Array,
      default: [],
    },
    item_id:{
      type: String,
      default: '',
    }
  },
  data() {
    return {
      search: "",
      dialogFormVisible: true,
      tableData: [],
      keyword: "",
      select: "",
      selectList: [],
      value6: [],

      province: "",
      city: "",
      select_list_obj: {
        province_list: [],
        city_list: [],
      },


      testing_product_classify: [], //检测仙品下拉数据
       detectionClassList: [], //检测分类下拉数据
       standartList: [], //检测标准下拉数据
      testProjectList: [], //检测项目下拉数据

      hasdetectionClassLists:[]
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleCancle() {
      console.log("handleCancle");
      this.$emit("hide_close", "");
    },
    // 选择
    handleSure() {
      console.log("handleCancle-------------------------");
      this.$emit("hide_price", {query:this.hasdetectionClassLists,item_id:this.item_id});
    },
    add() {
      this.$router.push({
        path: "/EnterpriseLibraryAdd",
      });
    },
    changeId() {
      console.log(this.province);
      this.getCity(this.province);
    },
    // 获取数据
    getData(key) {
      this.$http
        .post("adminapi/testing/project/list", {
          // page: this.nowPage,
          // limit: this.limit,
          keyword: this.search,
        })
        .then((res) => {
          this.tableData = res.data.list;
          console.log("this.tableData", this.tableData);
        })
        .catch((err) => {});
    },
    // 获取检测产品分类下拉
    getCommon() {
      this.$http
        .post("adminapi/common/select", { key: "testing_product_classify" })
        .then((res) => {
          this.testing_product_classify = res.data;
        })
        .catch((err) => {});
    },
    // 获取检测分类下拉
    getProductSelect(productClass) {
      this.product_title = productClass;
      //3.4
      this.$http
        .post("adminapi/common/testproject", {
          type: 1,
          product_title: this.product_title,
        })
        .then((res) => {
          // console.log(res.data);
          this.detectionClassList = res.data;
          // 3.4
          this.check_id[0].detectionClassArr = [];
          this.check_id[0].check_idArr = [];
          this.check_id[0].entrustment_Inspection_list = [];
          this.standartList = [];
          this.testProjectList = [];
          this.hastestProjectList = [];
          this.hastestProjectValue = [];
          this.hasdetectionClassLists = [];
          this.allChecked = false;
        })
        .catch((err) => {});
    },
    // 3.4
    // 根据检测分类获取检测标准下拉 检测分类change事件
    getStandardSelect(detectionClassArr) {
      // 清空
      console.log("----------------------------------清空", detectionClassArr);
      this.standartList = [];
      this.testProjectList = [];
      if (
        (this.hasdetectionClassLists != 0 &&
          detectionClassArr.length > this.hasdetectionClassLists.length + 1) ||
        (this.hasdetectionClassLists == 0 && detectionClassArr.length >= 2)
      ) {
        this.$tools.msg(
          this.$message,
          "",
          "请选择至项目后，选择其他项目",
          "warning"
        );

        this.check_id[0].detectionClassArr.map((ite, idx) => {
          if (ite == detectionClassArr[detectionClassArr.length - 1]) {
            this.check_id[0].detectionClassArr.splice(idx, 1);
          }
        });

        return;
      }
      let detLength = detectionClassArr.length;
      this.category_title = detectionClassArr[detLength - 1];
      if(!this.category_title){
        this.standartList = [];
        this.testProjectList = [];
        return
      }
      this.$http
        .post("adminapi/common/testproject", {
          type: 1,
          product_title: this.product_title,
          category_title: this.category_title,
        })
        .then((res) => {
          this.standartList = res.data;

          console.log("this.standartList", this.standartList);
        })
        .catch((err) => {});
    },
    // 3.4
    // 根据检测标准查找检测项目下拉框 testProjectList
    getTestproject(entrustment_Inspection_list) {
      console.log("entrustment_Inspection_list", entrustment_Inspection_list);
      let detLength = entrustment_Inspection_list.length;
      this.standard_title = entrustment_Inspection_list[detLength - 1];

      if(!this.standard_title){
        this.testProjectList = [];
        return
      }
      this.$http
        .post("adminapi/common/testproject", {
          type: 1,
          product_title: this.product_title,
          category_title: this.category_title,
          standard_title: this.standard_title,
        })
        .then((res) => {
          // console.log(res);
          this.testproject = res.data; //存起检测项目接口返回元数据
          this.testProjectList = res.data;
          console.log("this.testProjectList", this.testProjectList);

          let allcheck = 0;
          this.testProjectList.forEach((item) => {
            if (
              this.check_id[0].entrustment_Inspection_list.indexOf(
                item.key
              ) == -1
            ) {
              allcheck = allcheck + 1;
            }
          });

          // console.log(allcheck);

          if (
            allcheck == 0 &&
            this.check_id[0].entrustment_Inspection_list
          ) {
            this.allChecked = true;
          } else {
            this.allChecked = false;
          }
        })
        .catch((err) => {});
    },
     handleAll(e) {
      // 选中
      if (e) {
        this.allChecked = true;

        let isHas = false,
          push_list = [];
        this.testProjectList.map((item, index) => {
          this.check_id[0].entrustment_Inspection_list.push(item.key);

          if (!this.$tools.isEmpty(this.hasdetectionClassLists)) {
            this.hasdetectionClassLists.map((ite, index) => {
              if (ite.key == item.key) {
                isHas = true;
              }
            });
            if (!isHas) {
              this.hasdetectionClassLists.push(item);
            }
          } else {
            this.hasdetectionClassLists.push(item);
          }
        });
      } else {
        // 取消选中
        this.allChecked = false;
        this.check_id[0].entrustment_Inspection_list = [];
        this.testProjectList.map((item, index) => {
          this.hasdetectionClassLists.map((ite, idx) => {
            if (item.key == ite.key) {
              this.hasdetectionClassLists.splice(idx, 1);
            }
          });
        });
      }
    },
    entrustment_Inspection_AloneChange(en_item) {
      console.log('entrustment_Inspection_AloneChange',this.hasdetectionClassLists);
      let isHas = false,
        has_length = 0;
      if (!this.$tools.isEmpty(this.hasdetectionClassLists)) {
        console.log(111);
        this.hasdetectionClassLists.map((item, index) => {
          if (item.key == en_item.key) {
            // 已经有这条数据  删除
            this.hasdetectionClassLists.splice(index, 1);
            isHas = true;
            this.testProjectList.map((ite) => {
              if (item.key == ite.key) {
                has_length++;
              }
            });
            if (
              this.$tools.isEmpty(this.hasdetectionClassLists) ||
              has_length !=
                this.check_id[0].entrustment_Inspection_list.length
            ) {
              this.allChecked = false;
            }
          }
        });
        // 不包含本条数据
        if (!isHas) {
          console.log(333);
          this.hasdetectionClassLists.push(en_item);
          this.testProjectList.map((item, index) => {
            this.hasdetectionClassLists.map((ite, idx) => {
              if (item.key == ite.key) {
                has_length++;
              }
            });
          });
          if (has_length == this.testProjectList.length) {
            this.allChecked = true;
          } else {
            this.allChecked = false;
          }
        } else {
        }
      } else {
        console.log(222);
        this.hasdetectionClassLists.push(en_item);
        this.testProjectList.map((item, index) => {
          this.hasdetectionClassLists.map((ite, idx) => {
            if (item.key == ite.key) {
              has_length++;
            }
          });
        });
        if (
          has_length == this.testProjectList.length
        ) {
          this.allChecked = true;
        } else {
          this.allChecked = false;
        }
      }
    },
  },
  created() {
    if(!this.$tools.isEmpty(this.check_id)){
      this.check_id[0].productClass = ''
    }
    this.getCommon()

  },
  mounted() {},
};
</script>
<style lang="scss">

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.bg-purple-dark {
  background: #62b3ff;
}
.bg-purple {
  background: #62b3ff;
}
.bg-purple-light {
  background: #62b3ff;
}
.grid-content {
  // border-radius: 4px;
  min-height: 40px;
  line-height: 40px;
  text-align: center;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}


</style>
<style lang="scss" scoped>





// 1105
// 检测要求或说明的复选框
.checkbox_group {
  display: flex;
  flex-flow: column;
  .el-checkbox{
    padding: 10px 0;
  }
}
// 溢出滚动
/deep/.overflow_scroll_box {
  height: 246px;
  overflow-y: auto;
}
.border_x {
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
}
.border_r {
  border-right: 1px solid #ccc;
}
.border_l {
  border-left: 1px solid #ccc;
}
.padding_10 {
  padding-left: 10px;
}

/deep/.el-radio {
  line-height: 2.5;
}
.check_all_box{
  position: relative;
  .check_all{
    position: absolute;
    top: -20px;
    left: 10px;
  }
}
.sure_btn{
  position: absolute;
  bottom: 60px;
  left: 50%;
  right: 50%;
}
</style>